import React, { Suspense, lazy } from 'react';
import whySTDV from 'data/why-stdv';
import features from 'data/features';
import technologies from 'data/technologies';
import HeroBanner from 'components/home/HeroBanner';
import HeroBannerSuspense from 'components/utils/HeroBannerSuspense';
import { full_banner, phone, two_phone } from 'assets/images';
import { qr_ios, qr_android } from 'assets/images';
import dup_phone from 'assets/images/dup_phone.png';
const WhySTDV = lazy(() => import('components/home/WhySTDV'));
const Features = lazy(() => import('components/home/Features'));
const Technologies = lazy(() => import('components/home/Technologies'));
const Downloads = lazy(() => import('components/home/Downloads'));

export default function Home() {
  return (
    <>
      <Suspense fallback={<HeroBannerSuspense />}>
        <HeroBanner
          bgImgSrc={full_banner}
          title='Tương lai của ứng dụng Công tác Đảng'
          subTitle='Trong thời đại công nghệ thông tin hiện nay, việc cung cấp đầy đủ, kịp thời cho cán bộ, đảng viên những
                thông tin chính thống có ý nghĩa rất quan trọng.​ Nhận thức rõ điều đó, Trung tâm CNTT MobiFone, đã xây
                dựng và đưa vào triển khai phần mềm “Công tác Đảng”. Đặc biệt, việc đưa vào sử dụng phần mềm
                “Công tác Đảng” là bước đột phá, góp phần tạo sự thống nhất trong Đảng, đồng thuận trong xã
                hội.'
          videoSrc='https://www.youtube.com/embed/ZXE3ebzlZe8?si=Manx1wP9CyvQnvaS'
        />
      </Suspense>
      <Suspense fallback={null}>
        <WhySTDV
          title={
            <p className='text-4xl lg:text-5xl leading-none'>
              Tại sao nên chọn <span className='text-primary'>Công tác Đảng</span>
            </p>
          }
          subTitle='Ứng dụng dành riêng cho các Đảng viên, nhằm giúp Đảng viên có thể theo dõi thông tin, văn kiện, văn bản
        của Đảng bộ và dễ dàng thực hiện nghị quyết học tập và thi trực tuyến trên ứng dụng Công tác Đảng điện
        tử.'
          whySTDV={whySTDV}
        />
      </Suspense>
      <Suspense fallback={null}>
        <Features title='Công tác Đảng' subTitle='Tính năng ứng dụng' imgSrc={phone} features={features} />
      </Suspense>
      <Suspense fallback={null}>
        <Technologies
          title='Công tác Đảng'
          subTitle='Áp dụng công nghệ tương lai'
          imgSrc={two_phone}
          technologies={technologies}
        />
      </Suspense>
      <Suspense fallback={null}>
        <Downloads
          title='Công tác Đảng'
          subTitle='Đồng hành và trải nghiệm cùng với chúng tôi'
          imgSrc={dup_phone}
          appStoreDownload={{
            imgSrc: qr_ios,
            href: 'https://apps.apple.com/vn/app/s%E1%BB%95-tay-%C4%91%E1%BA%A3ng-vi%C3%AAn-mobifone/id1665853988?l=vi'
          }}
          chPlayDownload={{
            imgSrc: qr_android,
            href: 'https://play.google.com/store/apps/details?id=com.sotaydangvien&pcampaignid=web_share'
          }}
        />
      </Suspense>
    </>
  );
}
